export default "__VITE_ASSET__b67d50a5__"